export function recordingTimestamp(seconds: number) {
  const whole = Math.max(0, Math.floor(seconds));
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, '0')}`;
}

/** Stored transcript timestamps mark turns, rather than individual words. */
export function transcriptOffset(
  at: string,
  startedAt: string | null
): number | null {
  const offset = (Date.parse(at) - Date.parse(startedAt ?? '')) / 1000;
  return Number.isFinite(offset) ? Math.max(0, offset) : null;
}
